import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';
import { getStats} from '../services/UserService'

export const Classifica = (props) => {
  let [state, setState] = React.useState({
    stats: [],
  })

  const addZeroBefore = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  function convertMsToHM(milliseconds) {
    let seconds = Math.floor(milliseconds / 1);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;
    //return `${hours}:${minutes}:${seconds}`;
    return `${addZeroBefore(hours)}:${addZeroBefore(minutes)}:${addZeroBefore(seconds)}`;
  }

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

  const handleBackHome = (e) => {
      props.onChangeRoom(0);
  }

  React.useEffect(() => {
    getStats().then(response => {
      console.log(response.data);
      if (response.data){
        setState(prevState => ({
          ...prevState,
          stats: response.data,
        }));
      }
    });
  }, []);


  return(
    <div className="pages classifica" >
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>


      <div className='logo'>
        <Link onClick={handleBackHome} to="/"><ContentLanding stringToRet="logo" /></Link>
      </div>

      <div className="content">

        <h1>Classifica</h1>
        <table className="classifica">
        <tbody>
          {state.stats.map((item, i) => (item.room === 7) && <tr key={item + i}><td>{i+1}.</td><td>{item.nickname}</td><td>{convertMsToHM(item.time)}</td><td className="penality">{item.penalty}</td></tr>)}
        </tbody>
        </table>

        <Link className="btn btn-danger backTo" onClick={handleBackHome} to="/">Torna</Link>

      </div>


    </div>
  )
}
